import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { RootPaths } from '@/routes/paths';
import TokenService from '@/services/TokenService/TokenService';

type Props = {
  children: ReactNode;
};

export const AuthOrUsernameGuard = ({ children }: Props) => {
  const currentUserName = TokenService.getUserName();
  const shouldPasswordChange = TokenService.isPasswordChangeRequired();

  if (currentUserName === 'undefined' && shouldPasswordChange === null) {
    return <Navigate to={RootPaths.SIGN_IN} />;
  }

  return children;
};
